import {LitElement, html, css} from 'lit'
import Panel from 'bui/presenters/panel'
import Dialog from 'bui/presenters/dialog'
import 'bui/elements/spinner-overlay'

import {SHOE_SIZES, SHIRTS} from '../ref'

customElements.defineShared('steens-registration-confirm', class extends LitElement{

    constructor(){
        super()
        this.data = {}
    }

    static get styles(){return css`
        :host {
            display: grid;
            grid-template-rows: auto 1fr auto;
            height: 100%;
        }

        b-panel-toolbar {
            font-family: var(--font-header);
        }

        main {
            overflow: auto;
            padding: 1em;
        }

        footer {
            padding: 1em;
        }

        footer b-btn {
            /* border-radius: 0 0 4px 4px; */
            font-family: var(--font-header);
        }

        h1, h2, h3, h4 {
            margin: 0;
            font-family: var(--font-header);
        }

        [hidden] {
            display: none;
        }
    `}
	
	render(){return html`
        <b-spinner-overlay lg></b-spinner-overlay>
        <b-panel-toolbar>
            <span slot="title">Session ${this.data.session}</span>
        </b-panel-toolbar>
		<main>

            <b-text lg bold block>
                ${this.data.name}
            </b-text>
            <b-text block>${this.data.email}</b-text>
            
            <b-text ?hidden=${this.data.grade}>Grade <b>${this.data.grade}</b>, </b-text>
            <b-text><b>${this.data.school}</b></b-text>
            <b-text block ?hidden=${this.data.coach}>Coached by <b>${this.data.coach}</b></b-text>
            
            <b-hr short></b-hr>


            <h4>Address</h4>
            <div>${this.data.address}</div>
            <div>${this.data.city} ${this.data.state} ${this.data.zip}</div>

            

            <b-text ?hidden=${!this.data.balance}>

                <b-hr short></b-hr>
                
                <h4>Deposit</h4>
                <div>
                    $${this.data.deposit} <b-text italic muted=2>with $${this.data.balance} remaining balance</b-text>
                </div>

                <div><b-label filled="blue" ?hidden=${!this.data.coupon}>${this.data.coupon}</b-label> </div>

            </b-text>

            <b-hr short></b-hr>

            <h4>Preferences</h4>
            <div><b>${this.shirt}</b> shirt</div>
            <b-text block ?hidden=${!this.data.shoe}><b>${this.data.shoe}</b> shoe size</b-text>
            <div ?hidden=${!this.data.vegetarian}>Vegetarian diet</div>
            <div ?hidden=${!this.data.gluten_free}>Gluten free diet</div>

        </main>
        <footer>
            <b-btn pill color="theme" block lg @click=${this.register}>Register</b-btn>
        </footer>
	`}

    get shirt(){
        return SHIRTS[this.data.shirt] || '?'
    }

    open(data={}, session, result, cb){
        this.cb = cb
        this.data = data
        this.session = session
        this.result = result

        this.panel = this.panel || new Panel(this, {
            title: 'Confirm',
            width: '400px',
            height: '640px',
            anchor: 'center',
            quickJump: false,
            disableBackdropClick: true
        })

        this.panel.open()

        this.update()
    }

    async register(){

        this.spinner.show = true

        let url = APP_API_PATH+'/registration/register'

        let resp = await fetch(url, {
			method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
			body: JSON.stringify(this.data)
		})
        let status = resp.status

		resp = await resp.json().catch(err=>{})

        this.spinner.show = false

        if( !resp || resp.error ){
            Dialog.error({msg: resp.error||'Problem registering'}).modal()
            return
        }

        this.panel.close()
        this.cb&&this.cb()
    }
})

export default customElements.get('steens-registration-confirm')